var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"box-img"},[_c('img',{attrs:{"src":_vm.imgUrl}})]),_c('div',{staticClass:"box-content"},[_c('div',{staticClass:"box"}),_c('div',{staticClass:"box-text"},[_c('p',[_vm._v(_vm._s(_vm.published))]),_c('h2',[_vm._v(_vm._s(_vm.name))]),_c('span',{domProps:{"innerHTML":_vm._s(_vm.dec)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }